<template>
    <div>
        <HeaderParticipant
            :participants="participants"
            :participant="participant"
            @selectParticipants="selectParticipants"
            @changeSelect="changeSelect"
        />
        <v-row :class="{ 'mt-4': !age18 }">
            <v-col cols="12" md="12" sm="12">
                <div v-for="part in participantList" :key="part.id" class="ml-2 mr-2 mb-2">
                     <v-card class="elevation-4" :style="`background:${cardBGColor}`">
                        <v-card-text>
                            <HeaderCard :part="{...part, userId: part.id}"/>
                            <v-row>
                                <v-col class="contentRespTableFilter">
                                    <DataTableFilters :results="part.results" @openWarning="openWarning"/>
                                </v-col>
                            </v-row>
                        </v-card-text>
                     </v-card>
                </div>
            </v-col>
        </v-row>
        <v-dialog v-model="openWar" width="500">
            <v-card>
                <v-card-title class="text-h5">
                {{ $t("results.title-confirmed") }}
                </v-card-title>

                <v-card-text>
                    <p>
                        {{ $t("results.text-confirmed-1") }} <br />
                        {{ $t("results.text-confirmed-2") }}
                    </p>
                </v-card-text>

                <v-card-actions class="confirmedOpenRsp">
                    <v-spacer></v-spacer>

                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn btn_xs_rsp mt-sm-0 mt-1"
                        @click="viewRace(itemConfirmed)"
                    >
                        {{ $t("results.open-new-tab") }}
                    </v-btn>

                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn_xs_rsp mt-sm-0 mt-1"
                        text
                        @click="openWar = false"
                    >
                    {{ $t("common.cancel") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
    </div>
</template>

<script>
import AuthService from '@/services/AuthService';
import ResultsService from '@/services/ResultsService';
import Snack from '@/components/notifications/Snack';
import { VRow, VCol, VCard, VCardText, VDialog, VCardTitle, VCardActions, VSpacer, VBtn } from 'vuetify/lib';
import GeneralService from "@/services/GeneralService";
import HeaderCard from "@/components/HeaderCard";
import HeaderParticipant from "@/components/HeaderParticipant";
import DataTableFilters from "@/components/results/DataTableFilters";
import { mapState } from 'vuex';

export default {
    name:'Results',
    components:{
        VRow, VCol, Snack, VCard, VCardText, HeaderCard, HeaderParticipant, VDialog, VCardTitle, VCardActions, VSpacer, VBtn, DataTableFilters
    },
    data() {
      return {
        eventDateFilterValue: [],
        eventNameFilterValue: [],
        raceNameFilterValue: [],
        promNameFilterValue: [],
        snackbar: false,
        msg_snackbar: "",
        color_snackbar: "",
        buttonColor: '',
        cardBGColor: '',
        items: [],
        openWar: false,
        itemConfirmed: null,
        filterValue: '',
        bandLoadingPartSelected: false,
        participantList: []
      }
    },
    created(){
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
        this.cardBGColor = this.$store.getters.env.get('VUE_APP_BACKGROUND_CARD_PART');
        this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');
        this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');
        this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');
        this.getParticipants();
    },
    mounted() {
        const parent = this;
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                parent.$store.dispatch('setWindowWidthAction');
            });
        });
    },
    computed: {
        ...mapState({
            content2(state) {
                return this.$t("common.selectParticipants.content_2", { livelapsId: state.session.userid })
            },
            age18: (state) => state.session.age18,
            windowWidth: (state) => state.constants.windowWidth,
            userStore: (state) => state.session.user,
            participants: (state) => state.session.participants,
            participant: (state) => state.session.participantsSelected
        })
    },
    methods: {
        loadImage(url) {
            const urlImage = GeneralService.cleanImage(url, this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER'));
            return urlImage;
        },
        async getParticipants(){
            if(!this.bandLoadingParticipants) {
                if(this.userStore) {
                this.bandLoadingParticipants = true;
                this.$store.dispatch('setParticipantsAction');  
                } else {
                this.$store.dispatch('setUserAction');
                }
            }
        },
        showSnackBar(msg, color){
            this.snackbar = true;
            this.msg_snackbar = msg;
            this.color_snackbar = color;
            setTimeout(() => this.snackbar = false, 3000);
        },
        selectParticipants(){
            this.participantList = this.participantList.filter((el) => {
            const find = this.participant.find((ele) => { 
                return ele.userId ? el.userId == ele.userId : el.id == ele.id
                });
                return find ? true : false;
            });
            const usersId = this.participant.map((el) => { return el.userId; });
            this.getResultsUsers(usersId);
            AuthService.setAuthParticipants(this.userStore.id, this.participant); 
        },
        getResults(userId){
            let data = {
                userId: userId,
                authUserId: this.userId
            };
            let _results = [];
            ResultsService.getResults(data).then(response =>{
                if(response.data.success == 1){
                    response.data.message.map(function(value) {
                        _results.push({
                            eventName: value.eventName,
                            eventDate: value.eventDate,
                            raceId: value.raceId,
                            promName: value.promoterName,
                            raceName: value.raceName,
                            mode: value.mode
                        });
                    });
                }
            });
            this.items = _results;
        },
        getResultsUsers(usersId) {
            ResultsService.getResultsUsers({ usersId }).then(response => {
                this.participantList = this.participant.map((el) => {
                    const filter = response.data.message.filter((el1) => el.userId == el1.userId);
                    return {
                    ...el, 
                    results: filter.map((value) => {
                        return {
                            eventName: value.eventName,
                            eventDate: value.eventDate,
                            raceId: value.raceId,
                            promName: value.promoterName,
                            raceName: value.raceName,
                            mode: value.mode
                        };
                    })
                    }
                }); 
            });
        },
        viewRace(item){
            window.open(`${this.$store.getters.env.get('VUE_APP_ROOT')}/clients/?${item.raceId}`, "_blank");
            this.openWar = false;
        },
        changeSelect(selectParts){
            this.$store.commit('setParticipantsSelected', selectParts);
        },
        openWarning(item) {
            this.openWar = true;
            this.itemConfirmed = item;
        }
    },
    watch: {
        '$i18n.locale': {
            immediate: true, // Para que el watcher se active inmediatamente al montar el componente
            handler(/*newLocale, oldLocale*/)
            {
                this.bandLoadingParticipants = false;
                this.getParticipants();
            },
        },
        userStore(val) {
            if(val) {
                this.getParticipants();
            }
        },
        participant() {
            if(!this.bandLoadingPartSelected) {
                this.bandLoadingPartSelected = true;
                this.selectParticipants();
            }
        }
    }
  }
</script>

<style>
.btn{
  color: white !important;
}
@media (min-width: 600px) {
    .contentRespTableFilter .v-data-table-header, .contentRespTableFilter .headTableMobile {
        display: none;
    }
}
@media (max-width: 599px) {
  .contentRespTableFilter .headTable, .contentRespTableFilter .v-data-table-header-mobile {
        display: none;
  }
  .confirmedOpenRsp.v-card__actions {
        display: block;
  }
  .btn_bg, .btn_xs_rsp {
    max-width: 100%;
    min-width: auto !important;
    height: auto !important;
  }
  .btn_bg span, .btn_xs_rsp span {
    white-space: normal;
    max-width: 100%;
  }
  .lbl_search .v-text-field__details, .lbl_search .v-text-field__details .v-messages {
    min-height: 0px;
    margin-bottom: 0px !important;
  }
  .btn_bg {
    min-height: 50px;
  }
  .btn_xs_rsp {
    min-height: 36px;
  }
}
</style>
<style scoped>
.partImg{
    width: 40px;
    border-radius: 50%;
    height: 40px;
}
.partSpan{
    color: #000;
    position: absolute;
    top: 10px;
    left: 60px;
}
</style>